import { Button, TableCell, TableRow, Typography } from "@mui/material";

import type { CustomerListItem, CustomerType } from "../../../types";

interface Props {
  customer: CustomerListItem;
  onRemove: (customerId: number, customerType: CustomerType) => void;
  loading: boolean;
}

export function CustomerRow(props: Props) {
  const { customer, onRemove, loading } = props;
  const handleRemove = () => {
    const customerName =
      customer.first_name && customer.last_name
        ? `${customer.first_name} ${customer.last_name}`
        : customer.email;

    if (
      // eslint-disable-next-line no-alert
      window.confirm(
        `Are you sure you want to remove ${customerName} from your customer network?`,
      )
    ) {
      onRemove(customer.id, customer.type);
    }
  };

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body1">
          {customer.first_name} {customer.last_name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {customer.email}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1">{customer.company_name}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {new Date(customer.created_at).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell>
        <Button
          variant="outlined"
          size="small"
          disabled={loading}
          onClick={handleRemove}
          color="error"
        >
          Remove
        </Button>
      </TableCell>
    </TableRow>
  );
}
